/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDailyTrendResponse } from '../models/ApiResponseDailyTrendResponse';
import type { ApiResponseLatestScoreResponse } from '../models/ApiResponseLatestScoreResponse';
import type { ApiResponseMonthlyTrendResponse } from '../models/ApiResponseMonthlyTrendResponse';
import type { ApiResponseSafetyScoreDailyResponse } from '../models/ApiResponseSafetyScoreDailyResponse';
import type { ApiResponseSafetyScoreDetailResponse } from '../models/ApiResponseSafetyScoreDetailResponse';
import type { ApiResponseSafetyScoreMonthlyResponse } from '../models/ApiResponseSafetyScoreMonthlyResponse';
import type { ApiResponseSafetyScoreSummaryResponse } from '../models/ApiResponseSafetyScoreSummaryResponse';
import type { ApiResponseScoreByMonthResponse } from '../models/ApiResponseScoreByMonthResponse';
import type { ApiResponseTripAttributeResponse } from '../models/ApiResponseTripAttributeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SafeDrivingService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 기간 별 주행 상세 지표
   * Trip attributes by input period ( 기간 별 주행 상세 지표 )
   * @returns ApiResponseTripAttributeResponse OK
   * @throws ApiError
   */
  public tripAttribute({
    vin,
    start,
    end,
  }: {
    vin: string,
    start: string,
    end: string,
  }): CancelablePromise<ApiResponseTripAttributeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/trip-attributes/{vin}',
      path: {
        'vin': vin,
      },
      query: {
        'start': start,
        'end': end,
      },
    });
  }
  /**
   * 안전운전점수 요약 조회
   * 안전운전점수 요약 정보를 조회합니다.
   * @returns ApiResponseSafetyScoreSummaryResponse OK
   * @throws ApiError
   */
  public summary1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseSafetyScoreSummaryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/summary',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 월별 추이
   * Monthly trend ( 안전운전점수 월별 추이 )
   * @returns ApiResponseMonthlyTrendResponse OK
   * @throws ApiError
   */
  public monthlyTrend1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseMonthlyTrendResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/monthlyTrend/{vin}',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 월 안전운전 점수 상세
   * Score by month ( 월 안전운전 점수 상세 )
   * @returns ApiResponseScoreByMonthResponse OK
   * @throws ApiError
   */
  public scoreByMonth1({
    vin,
    month,
  }: {
    vin: string,
    month: string,
  }): CancelablePromise<ApiResponseScoreByMonthResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/monthlyDetail/{vin}',
      path: {
        'vin': vin,
      },
      query: {
        'month': month,
      },
    });
  }
  /**
   * 안전운전점수 월별 조회
   * 안전운전점수 월별 정보를 조회합니다.
   * @returns ApiResponseSafetyScoreMonthlyResponse OK
   * @throws ApiError
   */
  public monthly1({
    vin,
    startMonth,
    endMonth,
  }: {
    vin: string,
    startMonth: string,
    endMonth: string,
  }): CancelablePromise<ApiResponseSafetyScoreMonthlyResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/monthly',
      query: {
        'vin': vin,
        'startMonth': startMonth,
        'endMonth': endMonth,
      },
    });
  }
  /**
   * 안전운전점수 조회
   * 안전운전점수 조회
   * @returns ApiResponseLatestScoreResponse OK
   * @throws ApiError
   */
  public latest({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseLatestScoreResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/latest/{vin}',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 상세 조회
   * 안전운전점수 상세 정보를 조회합니다.
   * @returns ApiResponseSafetyScoreDetailResponse OK
   * @throws ApiError
   */
  public detail({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseSafetyScoreDetailResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/detail',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 일별 안전운전점수
   * Daily trend ( 일별 안전운전점수 )
   * @returns ApiResponseDailyTrendResponse OK
   * @throws ApiError
   */
  public dailyTrend1({
    vin,
    month,
  }: {
    vin: string,
    month: string,
  }): CancelablePromise<ApiResponseDailyTrendResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/dailyTrend/{vin}',
      path: {
        'vin': vin,
      },
      query: {
        'month': month,
      },
    });
  }
  /**
   * 안전운전점수 일별 조회
   * 안전운전점수 일별 정보를 조회합니다.
   * @returns ApiResponseSafetyScoreDailyResponse OK
   * @throws ApiError
   */
  public daily({
    vin,
    startDate,
    endDate,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
  }): CancelablePromise<ApiResponseSafetyScoreDailyResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/safe-driving/daily',
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
}
